import { useEffect, useState } from 'react';
import { devListKeys, devCreateKey, devRevokeKey, devGetKeyValue, DevApiKeyItem, devGetMe } from '../api/dev';
import Spinner from '../components/Spinner';

export default function DevKeys() {
  const [items, setItems] = useState<DevApiKeyItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [revealVal, setRevealVal] = useState('');
  const [revealLabel, setRevealLabel] = useState('');
  const [copied, setCopied] = useState(false);
  const [clientId, setClientId] = useState<string>('');

  async function refresh() {
    setLoading(true); setError(''); setRevealVal(''); setRevealLabel(''); setCopied(false);
    try { setItems(await devListKeys()); } catch (e: any) { setError(e?.message || String(e)); }
    finally { setLoading(false); }
  }
  useEffect(() => { refresh(); (async () => { try { const me = await devGetMe(); setClientId(me.oauthClientId || ''); } catch {} })(); }, []);

  async function generate() {
    try {
      const out = await devCreateKey();
      setRevealVal(out.key);
      setRevealLabel('Generated just now');
      setCopied(false);
      await refresh();
    } catch (e: any) { setError(e?.message || String(e)); }
  }
  async function revoke(k: DevApiKeyItem) {
    if (!confirm('Revoke this key?')) return;
    try { await devRevokeKey(k.keyId); refresh(); } catch (e: any) { setError(e?.message || String(e)); }
  }
  async function show(k: DevApiKeyItem) {
    try {
      setError('');
      const out = await devGetKeyValue(k.keyId);
      setRevealVal(out.key);
      setRevealLabel(`Key ID: ${k.keyId}`);
      setCopied(false);
    } catch (e: any) { setError(e?.message || String(e)); }
  }

  async function copyKey() {
    try { await navigator.clipboard.writeText(revealVal); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch {}
  }

  return (
    <div>
      <h2>Account</h2>
      <div className="card" style={{ marginBottom: 12 }}>
        <h3 style={{ marginTop: 0 }}>OAuth Client</h3>
        <div className="row" style={{ gap: 8, alignItems: 'center' }}>
          <div>Client ID: <code>{clientId || '-'}</code></div>
        </div>
        <div className="muted" style={{ marginTop: 6 }}>Client Secret: Contact AfricaWeather Support or your Account Manager to obtain or rotate the secret.</div>
      </div>
      <h3>API Keys</h3>
      {loading && <Spinner label="Loading..." />}
      <div className="row" style={{ gap: 8, marginBottom: 10 }}>
        <button className="btn success" onClick={generate}>Generate API Key</button>
        <button className="btn" onClick={refresh}>Refresh</button>
        {error && <span style={{ color: 'crimson' }}>Error: {error}</span>}
      </div>

      {revealVal && (
        <div className="card" style={{ marginBottom: 12 }}>
          <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontWeight: 700 }}>API Key</div>
              {revealLabel && <div className="muted" style={{ fontSize: 12 }}>{revealLabel}</div>}
            </div>
            <div className="row" style={{ gap: 6 }}>
              <button className="btn" onClick={copyKey}>{copied ? 'Copied!' : 'Copy'}</button>
              <button className="btn secondary" onClick={() => { setRevealVal(''); setRevealLabel(''); setCopied(false); }}>Hide</button>
            </div>
          </div>
          <pre style={{ marginTop: 10, background: '#0b1220', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 8, padding: 12, overflowX: 'auto' }}>
            <code>{revealVal}</code>
          </pre>
          <div className="muted" style={{ fontSize: 12, marginTop: 6 }}>Treat this like a password. Do not share.</div>
        </div>
      )}
      <div className="card">
        <table className="tbl">
          <thead><tr><th>Key ID</th><th>Status</th><th>Created</th><th></th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={4}><span className="muted">No keys</span></td></tr>}
            {items.map(k => (
              <tr key={k.keyId}>
                <td className="muted">{k.keyId}</td>
                <td>{k.status}</td>
                <td className="muted">{new Date(k.createdAt).toLocaleString()}</td>
                <td>
                  <div className="row" style={{ gap: 6 }}>
                    <button className="btn info" onClick={() => show(k)}>Show</button>
                    <button className="btn danger" onClick={() => revoke(k)}>Revoke</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

